import { type TextInputAutoComplete } from "./component";

export const maskValue = (value: string | undefined): string => {
  if (!value) return "";
  return value.replace(/./g, "*");
};

type InputInfo = {
  autoComplete: TextInputAutoComplete;
  maxLength?: number;
};
export const getInputInfo = (name: string | undefined): InputInfo | undefined => {
  if (!name) return;

  name = name.toLowerCase();
  if (name.includes("city")) {
    return {
      autoComplete: "address-level2",
      maxLength: 128
    };
  }
  if (name.includes("company")) {
    return {
      autoComplete: "organization",
      maxLength: 128
    };
  }
  if (name.includes("companytaxnumber")) {
    return {
      autoComplete: "off",
      maxLength: 32
    };
  }
  if (name.includes("email")) {
    return {
      autoComplete: "email",
      maxLength: 256
    };
  }
  if (name.includes("firstname")) {
    return {
      autoComplete: "given-name",
      maxLength: 128
    };
  }
  if (name.includes("lastname")) {
    return {
      autoComplete: "family-name",
      maxLength: 128
    };
  }
  if (name.includes("postalcode")) {
    return {
      autoComplete: "postal-code",
      maxLength: 32
    };
  }
  if (name.includes("street")) {
    return {
      autoComplete: "street-address",
      maxLength: 128
    };
  }
  if (name.includes("telephone")) {
    return {
      autoComplete: "tel",
      maxLength: 64
    };
  }
  if (name.includes("unit")) {
    return {
      autoComplete: "off",
      maxLength: 64
    };
  }
};
